// src/components/DeleteModal.js
import React from "react";

const DeleteModal = ({
  title,
  message,
  confirmText = "Delete",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) => {
  // close on ESC
  React.useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onCancel?.();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onCancel]);

  return (
    <div
      className="modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel?.(); // close on outside click
      }}
    >
      <div className="modal-card compact">
        <h3 className="modal-title">{title}</h3>
        {message && <p>{message}</p>}

        <div className="modal-actions">
          <button className="danger-btn" onClick={onConfirm}>
            {confirmText}
          </button>
          <button className="secondary-btn" onClick={onCancel}>
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;